import type { BaseAsyncProps } from "../types";

export interface GetUserEventHistoryProps {
  userId: string;
}

export interface RequestUserEventHistoryProps extends BaseAsyncProps {
  userId: string;
}

export type Event =
  | "abort"
  | "bounce"
  | "carriersend"
  | "click"
  | "deferral"
  | "delivery"
  | "deliveryfailure"
  | "dismiss"
  | "failure"
  | "frequencycap"
  | "impression"
  | "inboundreceive"
  | "influencedopen"
  | "iosforeground"
  | "markasspam"
  | "open"
  | "read"
  | "rejection"
  | "retry"
  | "send"
  | "smsfallback"
  | "softbounce"
  | "unsubscribe";

// Additional channels may be introduced by the backend, all channels must fall into one of these categories
export const BaseChannels = [
  "content_cards",
  "iam",
  "news_feed",
  "push",
  "webhook",
  "email",
  "sms",
  "rcs",
  "whats_app",
] as const;

export type Channel = (typeof BaseChannels)[number];

/** This is based upon app/controllers/controller_actions/apps/user_management.rb `user_event_history` method */
export interface EventHistoryEntry {
  event: Event;
  time: number;
  channel?: Channel;
  combination_token?: string;
  /** JSON string of component name → selected value from Nessie ComponentStore lookup. */
  component_values?: string;
  /** Per-component variant metadata for the combination token (dashboard enrichment). */
  component_variant_metadata?: Record<string, Record<string, string>>;
  canvas_id?: string;
  canvas_name?: string;
  campaign_id?: string;
  campaign_name?: string;
  canvas_step_id?: string;
  canvas_step_name?: string;
  message_variation_id?: string;
  message_variation_name?: string;
  destination?: string;
  destination_details?: string;
  abort_type?: string;
  is_sms_fallback?: boolean;
  id: string;
}

export interface UserEventHistoryResult {
  results: EventHistoryEntry[];
}

export interface UserEventHistoryRequestStatus {
  success: boolean;
}
